<div class="not-found">
  <h1 class="not-found__header">{{ 'NOT_FOUND.HEADER' | translate }}</h1>
  <img class="not-found__img" src="/assets/img/404.png" alt="" />
  <button mat-flat-button class="not-found__btn" (click)="navigateToHome($event)">{{ 'BUTTON_NAME.RETURN' | translate }}</button>
</div>
